export default {"src":"/_next/static/media/image-1-mob.2a99c35d.svg","height":90,"width":290,"blurWidth":0,"blurHeight":0};